import { PageHeader } from "@/widgets/page-header"
import { PageSubtitle } from "@/shared/ui/page-subtitle"
import { useAppDispatch } from "@/shared/lib/redux"
import {
    CreateUserInvitationModal,
    CreateUserInvitationsBulkModal,
    openBulkModal,
    openCreateModal,
} from "@/features/create-user-invitation"

export const UsersCreationPage = () => {
    const dispatch = useAppDispatch()

    return (
        <div className="_page_container">
            <PageHeader title="Пользователи" />
            <div className="flexbox">
                <PageSubtitle title="Создание пользователей" />
                <div className="w-full flex justify-end gap-2">
                    <button
                        className="form_cancel_button whitespace-nowrap"
                        onClick={() => dispatch(openBulkModal({}))}
                    >
                        Загрузить CSV
                    </button>
                    <button
                        className="form_handle_button whitespace-nowrap"
                        onClick={() => dispatch(openCreateModal({}))}
                    >
                        Создать пользователя
                    </button>
                </div>
            </div>
            <CreateUserInvitationModal />
            <CreateUserInvitationsBulkModal />
        </div>
    )
}
